module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      'landing-page': _vm.isLandingPage() === true
    }]
  }, [(!_vm.getIsLoggedIn || _vm.isCompanyLandingPage()) ? _c('Authorization-header') : _vm._e(), _vm._v(" "), (_vm.getIsLoggedIn && !_vm.isCompanyLandingPage()) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('conf-popup'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('inform-msg'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b7c2d40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Home.vue
// module id = 886
// module chunks = 1